
import React, { useEffect, useMemo, useState } from 'react';
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Button from '@mui/material/Button';



import { useParams } from 'react-router';
import FormBuilder, { IMedAppFormField } from '../../../../form';
import { useMutation, useQuery } from 'react-query';
import { ChargeDispute, Patient, Transaction } from '../../../../../models';
import api, { ViewRequest } from '../../../../../api/medAppApi';
import { putMessage } from '../../../../app/store/actions';
import { useDispatch } from 'react-redux';
import { titleCase, to2DecimalPlaces } from '../../../../../helpers';
import { reduxForm } from 'redux-form';
import { minLength, required } from '../../../../form/utils/validations';


const ResolveChargeDisputeForm: React.FC<any> = ({ mFields, name, handleSubmit, onSubmit }) => {

    const handleSubmitCallback = (value: any) => {
        onSubmit(value);
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitCallback)}>  <FormBuilder fields={mFields} name={name} />
            <Button type="submit" variant="contained">Continue</Button>
        </form>);
}

const ResolveChargeDisputeReduxForm = reduxForm<any, any>({
    form: 'apprve withdrawal-request'
})(ResolveChargeDisputeForm);
 

const ResolveChargeDispute: React.FC = () => {
    const dispatch = useDispatch();
    const [handled, setHandled] = useState(false);
    
    const [payload, setPayload] = useState<{chargedispute: ChargeDispute; patient: Patient} | undefined>()
    let { id } = useParams<{ id: string }>();

    const check = async (modelId: number) => {
       
    
        const criteria: ViewRequest = {
            modelName: "chargedispute",
            modelId,
            populate: "Transaction",
          };
      let ans = await api.viewModel<ChargeDispute>(criteria);
      if (ans.code !== 200)  {
        console.log(ans);
        throw new Error("Cannot Load data");
      }
      let ans2 = await api.getUserFromId({
        modelName: ans.data!.data.payload!.AssociatedWith.toLowerCase() as any,
        modelId: ans.data!.data.payload!.userId as any
      })

      return {
        chargedispute: ans.data!.data.payload!,
        patient: ans2.data!.data.payload! as Patient
      }

 }
 const {isLoading, data, isFetching, isError} = useQuery('load-charge-dispute-' + id,  () => check(parseInt(id || '-1', 10)), {enabled:  true});

    const mtnFn = async (data: {chargedispute: number, action: 'refund' | 'resolve', comment: string}) => {
        const resp = await api.resolveChargeDispute({}, {}, data);
        if(resp.errorData) {
            throw new Error(resp.errorData.problems || 'Something went wrong');
        } else if(resp.error) {
            throw new Error(resp.error || 'Something went wrong'); 
        }
        return resp;
    }
    const {mutate, isLoading: isResolving} =  useMutation({
        mutationFn: mtnFn,
        mutationKey: 'approve-withdrawal',
        onSuccess: (d) => {
            console.log(d);
            dispatch(putMessage({
                type: 'success',
                message: d.data!.data.dispute.status === 'Resolved' ? 'Successfully resolved dispute' : 'Refund has been initiated'
            }))
            setHandled(true)
        },
        onError: (error) => {
            dispatch(putMessage({
                type: 'error',
                message: (error as any).message
            }))
        }
    })


    const handleSubmit = (values: any) => {
        if(handled) {
            dispatch(putMessage({
                type: 'error',
                message: 'You have already handled this dispute'
            }))
            return;
        }
      console.log(values);
      mutate({
        chargedispute: payload!.chargedispute.id,
        ...values,
      })
        
    }

    useEffect(() => {
      if(isError) {
        dispatch(
          putMessage({
            type: "error",
            message: "Failed to load data",
          })
        );
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isError] )
    useEffect(() => {
      if(data) {
        setPayload(data)
      }
    }, [data])
    
    const fields: IMedAppFormField[] =useMemo(() => {
        if(!payload) {
            return []
        }
        const patient = payload.patient;
        const name = titleCase(`${patient.FirstName} ${patient.LastName}`)
        const transaction = payload.chargedispute.Transaction! as Transaction;
        const amountString = 'NGN' + to2DecimalPlaces(transaction.Amount/100, true)

        return [
            {
                name: 'amount',
                label:'Amount ' + amountString,
                type: 'text',
                defaultValue: amountString,
                
                inputExtras: {
                    disabled: true,
                    
                }

            }, {
                name: 'user',
                label: name,
                type: 'text',
                inputExtras: {
                    disabled: true,
                }

            },
            {
                variant: 'select',
                inputExtras: [{value: 'refund', label: 'Resolve as Refund'}, {value: 'resolve', label: 'Resolve as handled'}],
                name: 'action',
                label: 'Action',
                validate: [required],
                type: 'text',
           
            }, 
            {
                name: 'comment',
                label: 'Comment',
                type: 'text',
                inputExtras: {
                    multiline: true,
                    disabled: handled
                },
                defaultValue: 'None',
                validate: [required, minLength(2)],
    
            },
        ] as Array<IMedAppFormField>;
    }, [payload, handled])



 
        return (
            <Box style={{
                width: '100%'
            }}>
                <Box sx={{
                    width: '70%',
                    maxWidth: '700px',
                    minWidth: '250px',
                    marginLeft: '1em'
                }}>
                    {(isFetching || isResolving || isLoading) && <LinearProgress />}
                    <ResolveChargeDisputeReduxForm mFields={fields} namel="kosy" onSubmit={handleSubmit} />
                </Box>
            </Box>
        );
 

    
}

export default ResolveChargeDispute;
